export const indexTagsPath: string = "/tags";
export const newTagsPath: string = "/tags/new";
export const showTagsPath: string = "/tags/:id";
export const showTagsPathCreator = (id: number|string): string => `/tags/${id}`
export const editTagsPath: string = "/tags/:id/edit"
export const editTagsPathCreator = (id: number|string): string => `/tags/${id}/edit`
